import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { entityPartnerProductGridModel } from '~/entities/partner-product/grid'
import { Skeleton } from '~/shared/ui/components/Skeleton'

const skin = era.skin('routes/partner-program/grid')

PartnerProgramGridPage.displayName = 'PartnerProgramGridPage'
export function PartnerProgramGridPage(): JSX.Element {
  const isContentLoading = useUnit(
    entityPartnerProductGridModel.$partnerProductGridLoading
  )

  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <Skeleton pageType='grid' isLoading={isContentLoading}>
          <ui.RenderSkin name='partnerProgramGrid' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
